import React, { useContext } from 'react';
import classnames from 'classnames';
import TextRenderer from '../TextRenderer';
import PollAnswer from '../DaEditorWrapper/Viewer/PollAnswer';
import AnswerThumb from './_partials/AnswerThumb';
import { MobileContext } from '../Context/MobileContext';
import s from './PollOption.scss';
var imageSizeDesktop = parseInt(s['imageSizeDesktop'], 10);
var imageSizeMobile = parseInt(s['imageSizeMobile'], 10);
var PollOption = function (_a) {
    var answer = _a.answer, className = _a.className, canVote = _a.canVote, minimal = _a.minimal, onClick = _a.onClick;
    var isMobile = useContext(MobileContext);
    var handleClick = function () {
        if (!answer.answerId || !canVote) {
            return;
        }
        onClick(answer.answerId);
    };
    return (React.createElement("div", { className: classnames(s['root'], canVote && s['can-vote'], minimal && s['minimal'], className) },
        answer.deviationId && (React.createElement(AnswerThumb, { deviation: answer.image, size: isMobile ? imageSizeMobile : imageSizeDesktop, className: s['image-block'] })),
        React.createElement("div", { className: s['text-block'], onClick: handleClick },
            answer.textContent && (React.createElement(TextRenderer, { htmlExcerptLegacy: true, isPollWithHtmlExcerpt: true, className: s['answer-text'], textContent: answer.textContent, reactViewer: PollAnswer, viewerKey: answer.answerId })),
            !canVote && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s['progress-bar'] },
                    React.createElement("div", { className: s['progress-bar__value'], style: { width: answer.percentvotes + "%" } })),
                React.createElement("div", { className: s['percent-votes'] },
                    answer.percentvotes,
                    "%"))))));
};
PollOption.displayName = 'PollOption';
export default PollOption;
//# sourceMappingURL=PollOption.js.map